import { TaskDef } from "../../apis/mgmt/api";
import { DataFormWithButtonsLayout } from "../common/DataFormWithButtonsLayout";
import { EditableProps } from "../common/Editable";
import { TaskDefForm } from "./TaskDefForm";


export const TaskDefEditable = function (
    props: EditableProps<TaskDef>
) {
    return (
        <DataFormWithButtonsLayout editableProps={props}  saveAndStay={true}>
            <TaskDefForm {...props} />
        </DataFormWithButtonsLayout>
    );

};
